// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"825":"aa430da5","1940":"a8a2cd80","4850":"56088e29","8497":"aa430da5"}[chunkId] + ".chunk.css";
};